﻿import { CommonDataSharedService } from 'app/services/commonDataSharedService';
import { CommonRequestResponseService } from './../../services/common-request-response.service';
import { EnvService } from './../../services/env.service';
import { DataService } from './../../services/data.service';
import { NotificationService } from './../../services/notification.service';
import { WebService } from './../../services/web.service';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { LoginInfoProvider } from '../../ev-dal/login-info.provider';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
import { LoginService } from '../../services/login.service';
import { regexpPatterns } from '../../shared/patterns';
import { CollegeDetailService } from 'app/services';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {

  pattern = regexpPatterns;

  partnerId: string;              // needed?
  coachingHours: any;             // need refactoring (html in response from the server)
  impMessage: any;                // need refactoring (html in response from the server)
  detailData;                     // needed? (only for logo in html)
  returnUrl: string;
  partnerData: any;
  partnerLogo: string;
  partnerDetailDataSubscribe: Subscription;
  partnerName: string;

  constructor(
    private router: Router,
    private routes: ActivatedRoute,
    private webService: WebService,
    private notificationService: NotificationService,
    private dataService: DataService,
    private envService: EnvService,
    private loginInfoProvider: LoginInfoProvider,
    private bsModalService: BsModalService,
    private loginService: LoginService,
    private _commonRequestResponseService: CommonRequestResponseService,
    private _commonDataSharedService: CommonDataSharedService,
    private _collegeDetailService: CollegeDetailService
  ) { }


  ngOnInit() {
    this.routes.queryParams.subscribe((data: any) => {
      this.returnUrl = data.returnUrl;
    });

    if (localStorage.getItem('partnerDetail')) {
      this.partnerLogo = JSON.parse(localStorage.getItem('partnerDetail')).partnerLogo || './assets/img/envision_logo.png';
      this.partnerName = JSON.parse(localStorage.getItem('partnerDetail')).partnerName;
    }
    this.partnerDetailDataSubscribe = this._commonDataSharedService.partnerDetailData.subscribe((data: any) => {
      this.partnerData = data;
      this.partnerLogo = this.partnerData.partnerLogo || './assets/img/envision_logo.png';
      const partnerId = this.partnerData.partnerId;
      this.partnerId = partnerId;
      const userProfile = this.createUserProfile(partnerId);
      this.getCoachingHours(userProfile);
      this.getMessage(userProfile);
      this.partnerName = this.partnerData.partnerName;
    });
  }

  createUserProfile(partnerId) {
    const data = this._commonRequestResponseService.setUserDetailAPI({ partnerId: partnerId }, ['partnerId']);
    return data;
  }

  // Get info about coach operations hours and contacts
  getCoachingHours(userProfile) {
    this.webService.post('admin/getoperatingHours', userProfile)
      .subscribe(
        response => {
          this.coachingHours = response.message;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching coaching hours');
        });
  }

  // Get some important message
  getMessage(userProfile) {
    this.webService.post('admin/GetimportantMessage', userProfile)
      .subscribe(
        response => {
          this.impMessage = response.importantMessage;
        },
        () => {
          this.notificationService.show('error', 'Error while fetching important message');
        });
  }

  // Login
  signIn(form: NgForm) {
    this.partnerData = this.loginInfoProvider.parnerDetailData;
    if (this.partnerData.partnerId !== null) {
      if (form.valid) {
        this.envService.getIpAddress()
          .subscribe(
            ip => {
              const profile = {
                emailAddress: form.value.email,
                encryptedpassword: form.value.password,
                browser: this.envService.getBrowser(),
                platform: this.envService.getDevice(),
                IPv4Address: ip,
                PartnerId: this.partnerId || this.partnerData.partnerId
              };

              this.loginProcess(profile);

            }, () => {

              const profile = {
                emailAddress: form.value.email,
                encryptedpassword: form.value.password,
                browser: this.envService.getBrowser(),
                platform: this.envService.getDevice(),
                IPv4Address: 'notfound',
                PartnerId: this.partnerId || this.partnerData.partnerId
              };

              this.loginProcess(profile);

            });
      } else {
        this.notificationService.show('error', 'Please enter valid details');
      }
    } else {
      this.notificationService.show('error', 'Cannot find partner to login');
    }
  }


  loginProcess(profile) {
    this.loginService.login(profile)
      .subscribe(
        response => {
          this.dataService.getAllStaticEntities();
          this._collegeDetailService.getCollegeList({}).subscribe((data => {
            localStorage.setItem('collegeData', JSON.stringify(data.item))
          }))
          const isFirstlogin = this.loginInfoProvider.loginInfo.isFirstLogOn;
          this.returnUrl = (isFirstlogin && response.userRole === 'student') ? `/${response.userRole}/studentProfile` : this.returnUrl || `/${response.userRole}/home`
          this.router.navigate([this.returnUrl], { relativeTo: this.routes });
        },
        error => {
          this.notificationService.show('error', 'Error While Sign in');
        });
  }
  resetPassword() {
    this.bsModalService.show(ResetPasswordComponent);
  }

  ngOnDestroy() {
    this.partnerDetailDataSubscribe.unsubscribe();
  }

}
